module.exports = __webpack_public_path__ + "static/media/smiley.b0ebd9a3.svg";